import React, { useState } from 'react';

import MobileEducationModule from 'dpl/breeder_search_results/components/MobileEducationModule';
import DesktopEducationModule from 'dpl/breeder_search_results/components/DesktopEducationModule';
import EducationModuleModal from 'dpl/breeder_search_results/components/EducationModuleModal';
import { IS_MOBILE } from 'dpl/breeder_search_results/utils/constants';

export default function EducationModule() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      {isModalOpen && (
        <EducationModuleModal onCloseClick={() => setIsModalOpen(false)} />
      )}
      {IS_MOBILE ? (
        <MobileEducationModule onLearnMoreClick={() => setIsModalOpen(true)} />
      ) : (
        <DesktopEducationModule onLearnMoreClick={() => setIsModalOpen(true)} />
      )}
    </>
  );
}
